import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import BtnFav from '../card/BtnCardFavorite';
import { GetRegion } from '../../constants';
import * as constants from './constants';
import { converter } from '../../helpers/converter';

class ToolTip extends React.Component {
  constructor(props) {
    super(props);
    const { tooltipData } = this.props;
    if (this.props.tooltipData) {
      this.title = tooltipData.title;
      this.year = tooltipData.year;
      this.duration = tooltipData.duration;
      this.votesavg = tooltipData.votes_average;
      this.rating = tooltipData.rating_code;
      this.episode = tooltipData.episode_number;
      this.season = tooltipData.season_number;
      this.description = tooltipData.description_large;
      this.titleUri = tooltipData.title_uri;
      this.id = tooltipData.id;
    }
    this.state = {};
  }

  initDelay() {
    const { tooltipData } = this.props;
    if (!this.currentTO) {
      this.currentTO = setTimeout(() => {
        let tempid = null;
        if (tooltipData && tooltipData.id) {
          tempid = tooltipData.id;
        }
        this.setState({ waitingTime: true, tempid });
        this.currentTO = null;
      }, 1000);
    }
  }

  componentWillUnmount() {
    if (this.currentTO) {
      clearTimeout(this.currentTO);
    }
  }

  componentDidMount() {
    if (this.props.delay) {
      this.initDelay();
    }
  }

  render() {
    const { tooltipData, translations, x, y, user, withRi } = this.props;
    if (tooltipData == null || tooltipData.id == null) {
      return null;
    }

    if (tooltipData) {
      this.title = tooltipData.title;
      this.year = tooltipData.year;
      this.duration = tooltipData.duration;
      this.votesavg = tooltipData.votes_average;
      this.rating = tooltipData.rating_code;
      this.episode = tooltipData.episode_number;
      this.season = tooltipData.season_number;
      this.description = tooltipData.description_large;
      this.titleUri = tooltipData.title_uri;
      this.id = tooltipData.id;
    }

    if (!this.state.waitingTime || this.state.tempid !== tooltipData.id) {
      this.initDelay();
      return null;
    }

    let divSerie = null;
    if (this.episode)
      divSerie = (
        <div className="ToolTip-Serie">
          <div>
            {converter.convertApa(translations, constants.EPISODE)}
            <strong>{this.episode}</strong>
          </div>
          <div>
            {converter.convertApa(translations, constants.SEASON)}
            <strong>{this.season}</strong>
          </div>
          <div>
            {converter.convertApa(translations, constants.COMMON_PUBLISHYEAR)}
            <strong>{this.year}</strong>
          </div>
        </div>
      );

    let cardUrl = null;
    cardUrl = `/
      ${GetRegion()}/vcard/tercernivel/${this.titleUri}/${this.id}`;

    let flechaClass = null;
    if (x && y) {
      flechaClass = 'flecha-';
      flechaClass += x > 0 && !withRi ? 'left-' : 'right-';
      flechaClass += y > 0 ? 'top' : 'bottom';
    }
    const dispP = !window.avoidTooltilTimer ? 'inital' : 'none';
    return (
      <div
        id="tooltip"
        className="ToolTip-Container"
        style={{
          top: y + 'px',
          left: x + 'px',
          display: dispP,
        }}
      >
        <div className={flechaClass} />
        <div className="ToolTip-Header">
          <div className="ToolTip-Title">
            <Link to={cardUrl}>
              <h3>{this.title}</h3>
            </Link>
          </div>
          <div className="ToolTip-Info">
            <span>{this.year}</span>
            <span>{this.duration}</span>
            <span className="rate-tooltip" />
          </div>
          <div className="ToolTip-Rate">{this.rating}</div>
        </div>
        <div className="ToolTip-Body">
          {divSerie}
          <div className="ToolTip-Desc">
            <strong>
              {converter.convertApa(translations, constants.SYNOPSIS)}
            </strong>
            {this.description}
          </div>
        </div>
        <div className="ToolTip-Footer">
          <div className="ToolTip-Buttons">
            <BtnFav
              user={user}
              translations={translations}
              onClick={this.onClick}
              group={tooltipData}
            />
            <div className="ToolTip-Detalles">
              <Link to={cardUrl}>
                {converter.convertApa(translations, constants.MORE_INFO)}
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ToolTip.propTypes = {};

function mapStateToProps(state) {
  return {
    translations: state.translations,
    user: state.user,
    router: state.routing,
  };
}

export default connect(mapStateToProps)(ToolTip);
